import env from '@/env';
import LOAD_STATUS from './load-status';

export { LOAD_STATUS };

// 商家端状态
export const MERCHANT_STATUS = [
  {
    title: '全部',
    val: '',
  },
  {
    title: '未上线',
    val: 0,
  },
  {
    title: '已上线',
    val: 1,
  },
];

// 活动级别    val范围是10000~99999，不然排序会有问题！！！！！！！！！！
export const OTHER_LEVEL_CODE = 99999;

// 不在导航中展示，包括顶部导航和侧边导航
// 这种方式不太好
export const DICT_IGNORE_PATH = {
  '': true,
  '*': true,
  '/404': true,
  '/nopower': true,
  '/activity-manage/create': true,
  '/resources-apply': true,
  '/activity-manage/detail': true,
  '/activity-manage/edit': true,
  '/activity-manage/check': true,
};

export const footerLink = [
  {
    id: 0,
    img: '//img30.360buyimg.com/pop/jfs/t1/125116/14/23588/1224/622048a5E37e43ec5/f2c379b645bce171.png',
    link: 'http://ipaas.jd.com',
    text: 'iPaaS',
  },
  {
    id: 1,
    img: '//img30.360buyimg.com/pop/jfs/t1/208055/32/18596/1330/622048a5E0f329289/e6e4c82e8fa7e227.png',
    link: 'https://babel.m.jd.com/active/babelCommon/index.html#/',
    text: '通天塔',
  },
  {
    id: 2,
    img: '//img30.360buyimg.com/pop/jfs/t1/149599/39/23431/1909/622048a5Efadd9e11/06c5b7d59a156a77.png',
    link: 'https://ace.jd.com/launch/#/',
    text: '投放',
  },
  {
    id: 4,
    img: 'https://img30.360buyimg.com/pop/s16x16_jfs/t1/145857/36/15667/3215/5fbcfbb8E5a035f54/c01182a08cb464f2.png',
    link: 'https://ling.jd.com/?autologin=1',
    text: '羚珑',
  },
];

export const ACTIVITY_OWNER = [
  {
    title: '全部',
    val: '',
  },
  {
    title: '仅我发布',
    val: 2,
  },
  {
    title: '他人发布',
    val: 3,
  },
];

// 这个值同步给后端了，如有改动需要同步
// 货币化级别
// 修改之前要注意下面的 ONLY_HAS_H_B_H_LEVELS 是去除了不限的货币化级别
export const H_B_H_LEVELS = [
  {
    title: '不限',
    val: '',
    color: '',
  },
  {
    title: '货币化级别S',
    val: 1,
    color: '#F2270C',
  },
  {
    title: '货币化级别A+',
    val: 2,
    color: '#464C5B',
  },
  {
    title: '货币化级别A',
    val: 3,
    color: '#464C5B',
  },
  {
    title: '货币化级别B+',
    val: 5,
    color: '#464C5B',
  },
  {
    title: '货币化级别B',
    val: 6,
    color: '#464C5B',
  },
  {
    title: '货币化级别C+',
    val: 8,
    color: '#464C5B',
  },
  {
    title: '货币化级别C',
    val: 9,
    color: '#464C5B',
  },
  {
    title: '其他',
    val: 29,
    color: '#464C5B',
  },
];

export const ONLY_HAS_H_B_H_LEVELS = H_B_H_LEVELS.slice(1);

export function getHBHLevelName(level, otherLevel) {
  return level != null
    ? Number(level) === OTHER_LEVEL_CODE
      ? otherLevel || ''
      : H_B_H_LEVELS[level]?.title || ''
    : '';
}

// 红色
const ACTIVITY_LEVEL_COLOR1 = '#F2270C';
// 黄色
const ACTIVITY_LEVEL_COLOR2 = '#F6C129';
// 灰色
const ACTIVITY_LEVEL_COLOR3 = '#657798';

// 红色 -> 红色
const ACTIVITY_CANLENDAR_COLOR1 = '#F44C19 #F2270C';
const ACTIVITY_CANLENDAR_BG_COLOR1 = '#FDE9E6';
// 绿色 -> 黄色
const ACTIVITY_CANLENDAR_COLOR2 = '#4BD6AE #01BEB8';
const ACTIVITY_CANLENDAR_BG_COLOR2 = '#DCF9F6';
// 紫色 -> 灰色
const ACTIVITY_CANLENDAR_COLOR3 = '#7170F7 #5D5CFB';
const ACTIVITY_CANLENDAR_BG_COLOR3 = '#E5E5FE';

// 活动级别    val范围是10000~99999，不然排序会有问题！！！！！！！！！！
export const ACTIVITY_LEVELS = [
  {
    title: '不限',
    val: '',
    color: '',
  },
  {
    val: 10000,
    title: '事业群全年S级',
    color: '#0E2FB3',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR1,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR1,
  },
  {
    val: 10100,
    title: '平台大促S级',
    color: '#D9363C',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR1,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR1,
  },
  {
    val: 10200,
    title: '平台大促A+级',
    color: '#FF4C4C',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR1,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR1,
  },
  // 平台大促A级、平台大促B级、王牌超级品牌日、MINI超级品牌日、超级品类日、授权MINI超级品牌日、授权超级品类日、宠粉日、战略超级新计划、王牌超级新计划、授权王牌超级新计划、PLUSDAY、PLUS A计划、超级IP日、
  {
    val: 10300,
    title: '平台大促A级',
    color: '#FF7A75',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 10400,
    title: '平台大促B级',
    color: '#FFA398',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 10500,
    title: '王牌超级品牌日',
    color: '#FD8C0E',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 10600,
    title: 'MINI超级品牌日',
    color: '#FEB00E',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 10700,
    title: '超级品类日',
    color: '#0B9E5E',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 10800,
    title: '授权MINI超级品牌日',
    color: '#FFC72C',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 10900,
    title: '授权超级品类日',
    color: '#17C574',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 11000,
    title: '宠粉日',
    color: '#FFB5AC',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 11100,
    title: '战略超级新计划',
    color: '#0094D9',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 11200,
    title: '王牌超级新计划',
    color: '#02B7FF',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 11300,
    title: '授权王牌超级新计划',
    color: '#2BCAFF',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 11400,
    title: 'PLUSDAY',
    color: '#26336C',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 11500,
    title: 'PLUS A计划',
    color: '#233999',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  {
    val: 11700,
    title: '超级IP日',
    color: '#B75AF0',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR2,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR2,
  },
  // 另一种颜色
  {
    val: 11800,
    title: '事业部S级',
    color: '#1C48D9',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR3,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR3,
  },
  {
    val: 11900,
    title: '事业部A级',
    color: '#2D64FF',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR3,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR3,
  },
  {
    val: 12000,
    title: '事业部B级',
    color: '#5789FF',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR3,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR3,
  },
  {
    title: '其他',
    val: OTHER_LEVEL_CODE,
    color: '#93ABEE',
    colorInCanlendar: ACTIVITY_CANLENDAR_COLOR3,
    bgColorInCanlendar: ACTIVITY_CANLENDAR_BG_COLOR3,
  },
];

// 这个缓存了所有信息，不只有val: title的映射
export const CACHE_ACTIVITY_LEVELS_MAP = {};

ACTIVITY_LEVELS.forEach((item) => {
  CACHE_ACTIVITY_LEVELS_MAP[item.val] = item;
});

// 如果活动等级小于100就取货币化等级的名字
export function getLevelName(level, otherLevel) {
  if (level == null || level == '') return '';
  if (Number(level) === OTHER_LEVEL_CODE) return otherLevel || '';
  if (Number(level) <= 100) return ACTIVITY_HBH_LEVELS_MAP[level] || '';
  return ACTIVITY_LEVELS_MAP[level];
}

export function getLevelColorForTag(level) {
  if (level == null) return '';
  if (Number(level) === OTHER_LEVEL_CODE || Number(level) <= 100)
    return CACHE_ACTIVITY_LEVELS_MAP[OTHER_LEVEL_CODE]?.color;
  return CACHE_ACTIVITY_LEVELS_MAP[level]?.color;
}

// 渠道 需要同步给后端
export const ACTIVITY_CHANNELS = [
  {
    title: '全渠道',
    val: '',
  },
  {
    title: 'APP',
    val: 1,
  },
  {
    title: 'PC',
    val: 2,
  },
  {
    title: 'WQ',
    val: 3,
  },
  {
    title: '小程序',
    val: 4,
  },
  {
    title: 'M页',
    val: 5,
  },
];

// 这个值同步给后端了，如有改动需要同步
// export const ACTIVITY_LEVELS = [
//   {
//     title: '全部',
//     val: -10,
//     color: ''
//   },
//   {
//     title: '事业群全年S级',
//     val: 2,
//     color: '#F2270C'
//   },
//   {
//     title: '平台大促S级',
//     val: 3,
//     color: '#F2270C'
//   },
//   {
//     title: '平台大促A+级',
//     val: 4,
//     color: '#F2270C'
//   },
//   {
//     title: '平台大促A级',
//     val: 5,
//     color: '#F2870C'
//   },
//   {
//     title: '平台大促B级',
//     val: 6,
//     color: '#F2870C'
//   },
//   {
//     title: '王牌超级品牌日',
//     val: 7,
//     color: '#F2870C'
//   },
//   {
//     title: 'MINI超级品牌日',
//     val: 8,
//     color: '#F2870C'
//   },
//   {
//     title: '超级品类日',
//     val: 9,
//     color: '#F2870C'
//   },
//   {
//     title: '授权MINI超级品牌日',
//     val: 10,
//     color: '#F2870C'
//   },
//   {
//     title: '授权超级品类日',
//     val: 11,
//     color: '#F2870C'
//   },
//   {
//     title: '宠粉日',
//     val: 12,
//     color: '#F2870C'
//   },
//   {
//     title: '战略超级新计划',
//     val: 13,
//     color: '#F2870C'
//   },
//   {
//     title: '王牌超级新计划',
//     val: 14,
//     color: '#F2870C'
//   },
//   {
//     title: '授权王牌超级新计划',
//     val: 15,
//     color: '#F2870C'
//   },
//   {
//     title: 'PLUSDAY',
//     val: 16,
//     color: '#F2870C'
//   },
//   {
//     title: 'PLUS A计划',
//     val: 17,
//     color: '#F2870C'
//   },
//   {
//     title: '超级IP日',
//     val: 18,
//     color: '#F2870C'
//   },
//   {
//     title: '事业部S级',
//     val: 19,
//     color: '#464C5B'
//   },
//   {
//     title: '事业部A级',
//     val: 20,
//     color: '#464C5B'
//   },
//   {
//     title: '事业部B级',
//     val: 21,
//     color: '#464C5B'
//   },
//   {
//     title: '货币化级别S',
//     val: 22,
//     color: '#F2270C'
//   },
//   {
//     title: '货币化级别A+',
//     val: 23,
//     color: '#464C5B'
//   },
//   {
//     title: '货币化级别A',
//     val: 24,
//     color: '#464C5B'
//   },
//   {
//     title: '货币化级别B+',
//     val: 25,
//     color: '#464C5B'
//   },
//   {
//     title: '货币化级别B',
//     val: 26,
//     color: '#464C5B'
//   },
//   {
//     title: '货币化级别C+',
//     val: 27,
//     color: '#464C5B'
//   },
//   {
//     title: '货币化级别C',
//     val: 28,
//     color: '#464C5B'
//   },
//   {
//     title: '其他',
//     val: 29,
//     color: '#464C5B'
//   }
// ]

export const ACTIVITY_STATUS = [
  {
    title: '全部',
    val: '',
  },
  // {
  //   title: '草稿',
  //   val: 2
  // },
  {
    title: '已发布',
    val: 3,
  },
  {
    title: '生效中',
    val: 4,
  },
  {
    title: '已失效',
    val: 5,
  },
  // {
  //   title: '数据有效',
  //   val: 6
  // }
];

export const ACTIVITY_LEVELS_MAP = {};

export const ACTIVITY_HBH_LEVELS_MAP = {};

export const ACTIVITY_STATUS_MAP = {};

export const ACTIVITY_TAG_MAP = {};

// 现在的活动级别小于100的都是现在的货币化级别
export function transformLevelAndHBHLevel(level, otherLevel) {
  if (level != null && level != '' && Number(level) <= 100 && Number(level) !== OTHER_LEVEL_CODE) {
    otherLevel = ACTIVITY_HBH_LEVELS_MAP[level] || '';
    level = String(OTHER_LEVEL_CODE);
  }

  return {
    level,
    otherLevel,
  };
}

function transformArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.val] = item.title;
  });
}

function transformArr3Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.val] = item.color;
  });
}

transformArr2Map(ACTIVITY_LEVELS, ACTIVITY_LEVELS_MAP);

transformArr2Map(H_B_H_LEVELS, ACTIVITY_HBH_LEVELS_MAP);

transformArr2Map(ACTIVITY_STATUS, ACTIVITY_STATUS_MAP);

transformArr3Map(ACTIVITY_LEVELS, ACTIVITY_TAG_MAP);

export function getLevel(l) {
  const level = ACTIVITY_LEVELS_MAP[l];
  return level || '';
}

export const LINK_PAY_ORDER = 'https://jdhb.jd.com/contract/#/orderContractSign';

export const LINK_CONFIG_RESOURCE = 'https://jdhb.jd.com/contract/#/putInManage';

// 活动个对比的类别 1 表示对比活动 2 表示对比会场
export const VS_TYPE = {
  ACTIVITY: 1,
  ROOM: 2,
};

export const SCOPE_TYPE = {
  ALL: 0,
  AVERAGE: 1,
};
export const RESOURCE_MANAGE_NOTICE =
  '查询时只能查询出在本人管理权限范围内、过了招商时间且还没过生效时间的资源，其余不展示。';

// 数据面板数据加载出错错误提示
export const ERROR_MSG_DATA_PANEL = '请稍后重试';

// antd样式前缀，防止样式污染子应用
export const prefixCls = 'ant-acore';

// antd-icon样式前缀，改成【'anticon'】切换drip-icon后可以兼容
export const iconPrefixCls = 'anticon';

// 携带
export const acorekey = 'from';

export const acorekeyvalue = 'acore';

export const acoreversionkey = 'acore_version';

export const acoreversion830value = '830';

export const insideIframe = window.self !== window.top;

// 登录页面地址
export const PATH_TO_LOGIN = new URL(`${env.ACORE_DOMAIN}/login.html`, location.origin).href;
export const PATH_TO_INDEX = new URL(`${env.ACORE_DOMAIN}`, location.origin).href;

export default {
  // actcenter.jd.local
  API_ORIGIN: 'https://actcenter.jd.care',
  DICT_IGNORE_PATH,
  LINK_PAY_ORDER,
  LINK_CONFIG_RESOURCE,
  getLevel,
};
